/**
 * DataSource: Sirenes (M4)
 * ------------------------
 * Hoje: mock — POC mostra status fake + log de acionamentos manuais.
 * Futuro: espelhar o app TCal de acionamento (manual + automático via
 *         tiltímetros). Telles: "disponibilizar o conjunto físico de
 *         acionamento das sirenes junto ao computador".
 *
 * R-B08 — Acionamento remoto restrito ao Perfil B com confirmação
 *         dupla e registro auditável.
 */

import type { DamId } from '@/domain';
import type { DataSourceMeta } from './types';

export interface Sirene {
  id: string;
  damId: DamId;
  codigo: string;          // 'SIR-01'
  label: string;
  zona: 'ZAS' | 'ZSS' | 'manutencao';
  isOnline: boolean;
  ultimoTeste: Date | null;
}

export type AcionamentoSirene = {
  sireneId: string;
  acionadoEm: Date;
  acionadoPor: string;         // engineerId
  motivo: string;
  via: 'tiltimetro_automatico' | 'manual_perfil_b';
};

export interface SirenesDataSource extends DataSourceMeta {
  list(damId?: DamId): Promise<Sirene[]>;
  acionar(input: { sireneId: string; motivo: string; engineerId: string }): Promise<AcionamentoSirene>;
  listAcionamentos(opts?: { limit?: number }): Promise<AcionamentoSirene[]>;
}

const MOCK_SIRENES: Sirene[] = [
  { id: 'sir-01', damId: '' as DamId, codigo: 'SIR-01', label: 'Sirene ZAS A', zona: 'ZAS', isOnline: false, ultimoTeste: null },
  { id: 'sir-02', damId: '' as DamId, codigo: 'SIR-02', label: 'Sirene ZAS B', zona: 'ZAS', isOnline: false, ultimoTeste: null },
  { id: 'sir-03', damId: '' as DamId, codigo: 'SIR-03', label: 'Sirene ZSS',   zona: 'ZSS', isOnline: false, ultimoTeste: null },
];

// Estado in-memory pra POC. Some no F5 — intencional pra demo.
const acionamentosPoc: AcionamentoSirene[] = [];

export const mockSirenes: SirenesDataSource = {
  mode: 'mock',
  pendingIntegration: {
    owner: 'TCal',
    name: 'Espelho do app de sirenes',
    status: 'pendente',
    description:
      'Espelhar o aplicativo TCal de acionamento (manual e automático via tiltímetros). ' +
      'Aguardando login + protocolo de acionamento. ' +
      'POC registra acionamentos in-memory pra demo do fluxo.',
  },

  async list() {
    return MOCK_SIRENES;
  },

  async acionar(input) {
    const a: AcionamentoSirene = {
      sireneId: input.sireneId,
      acionadoEm: new Date(),
      acionadoPor: input.engineerId,
      motivo: input.motivo,
      via: 'manual_perfil_b',
    };
    acionamentosPoc.unshift(a);
    return a;
  },

  async listAcionamentos({ limit = 20 } = {}) {
    return acionamentosPoc.slice(0, limit);
  },
};

// TODO[INTEGRACAO-TCAL-SIRENES]: receber do TI da TCal:
//   1. Endpoint de acionamento (com auth)
//   2. Webhook de retorno (sirene tocando / falha)
//   3. Política de confirmação dupla (R-B08)
// → criar `tcalSirenes: SirenesDataSource` com mode='integrated'.
